import { __module as n } from "./index.es61.js";
n.exports = {
  get firstChild() {
    var e = this.children;
    return e && e[0] || null;
  },
  get lastChild() {
    var e = this.children;
    return e && e[e.length - 1] || null;
  },
  get nodeType() {
    return t[this.type] || t.element;
  }
};
var r = {
  tagName: "name",
  childNodes: "children",
  parentNode: "parent",
  previousSibling: "prev",
  nextSibling: "next",
  nodeValue: "data"
}, t = {
  element: 1,
  text: 3,
  cdata: 4,
  comment: 8
};
Object.keys(r).forEach(function(e) {
});
var a = n.exports;
export {
  a as n
};
//# sourceMappingURL=index.es40.js.map
